module.exports = __webpack_public_path__ + "assets/img/33.2b8351d5.png";